module.exports = __webpack_public_path__ + "img/students2.9c703e00.jpg";